export enum ErrorTypes {
	PAGE_MODEL = 'PAGE_MODEL',
	DATA = 'DATA',
}

export type LoadDataRejectReason = {
	type: keyof typeof ErrorTypes;
	message: string;
	isInStore?: boolean;
};

export type LoadDataReject = (reason: LoadDataRejectReason) => void;
